<template>
  <modal :show.sync="showModal" id="updateMultiplevalues" size="lg">
    <template slot="header">
      <h5 class="modal-title" id="exampleModalLabel">
        {{modalLabel()}}
        <br>
        <small v-show="!commercial.is_open" class="text-warning">Atenção! Período comercial encontra-se fechado</small>
      </h5>
    </template>
    <validation-observer ref="formValidator">
      <form role="form">
        <div class="row">
          <div class="col-md-4" >
            <base-input
              v-if="commercialProducts.length <= 1"
              group class="mb-3"
              :required="true"
              v-model="formStructure.packing"
              placeholder="0"
              :disabled="!commercial.is_open"
              :valid="true"
              label="Quantidade da Embalagem"
              rules="required"
              mask="volume"
            />
          </div>
          <div class="col-md-4" >
            <base-input
              v-if="commercialProducts.length <= 1"
              group class="mb-3"
              :valid="true"
              :required="true"
              v-model="formStructure.purchase_price"
              :disabled="!commercial.is_open"
              label="Custo de Compra"
              rules="required"
              mask="volume"
            />
          </div>
          <div class="col-md-4" >
            <base-input
              placeholder="Juros após data de pagamento"
              aria-label="Juros após data de pagamento"
              v-model="formStructure.accrual_interest"
              :disabled="!commercial.is_open"
              group class="mb-3"
              :required="true"
              label="Financeiro Vegetal"
              append-icon="fa fa-percent"
              rules="required"
              mask="volume"
            />
          </div>
          <div class="col-md-12 div-striped mb-3" style="max-height: 100px;" v-for="(addition, index) in additions" :key="addition.tabe_cta">
            <div class=" row">
              <div class="col-md-6">
                <base-input 
                  v-model="addition.value"
                  group class="mb-3"
                  :valid="true"
                  name="percentage"
                  :required="true"
                  :label="addition.name"
                  :disabled="!commercial.is_open"
                  append-icon="fa fa-percent" 
                  placeholder="Acréscimo"
                  mask="volume"
                />
              </div>
              <div class="row mt-5 ml-6">
                <base-radio
                  name="0"
                  :value="0"
                  v-model="newAdditions[index].operation"
                  :disabled="!commercial.is_open"
                  inline
                >
                  <strong>Somar</strong>
                </base-radio>
                <base-radio
                  name="1"
                  :value="1"
                  v-model="newAdditions[index].operation"
                  :disabled="!commercial.is_open"
                  inline
                  class="ml-4"
                >
                  <strong>Subtrair</strong>
                </base-radio>
              </div>
            </div>
          </div>
          <div class="col-md-4" >

              <base-input
                group class="mb-3"
                append-icon="fa fa-percent"
                v-model="formStructure.discount_supplier"
                :disabled="!commercial.is_open"
                :required="true"
                placeholder="Desconto do Fornecedor"
                aria-label="Desconto do Fornecedor"
                label="Desconto do Fornecedor"
                rules="required"
                mask="volume"
              />
          </div>
          <div class="col-md-4" >
            <base-input
              :required="true"
              group class="mb-3"
              v-model="formStructure.vegetal_interest"
              :disabled="!commercial.is_open"
              placeholder="Juros vegetal"
              append-icon="fa fa-percent"
              label="Margem Vegetal"
              rules="required"
              mask="volume"
            />
          </div>
          <div class="col-md-4" >
            <base-input
              :key="gainMarginKey"
              :required="true"
              group
              class="mb-3"
              :value="formStructure.gain_margin_product || commercialBrand.gain_margin"
              @input="formStructure.gain_margin_product = $event"
              :disabled="!commercial.is_open"
              placeholder="Margem de lucro vegetal (produto)"
              append-icon="fa fa-percent"
              label="Margem de lucro da vegetal"
              rules="required"
              mask="volume"
              />
          </div>
          <div class="col-md-6 mb-3" >
            <label class="form-control-label">Meses para não aplicar</label>
            <multiselect
              :required="true"
              v-model="formStructure.unapplicable_months"
              :disabled="!commercial.is_open"
              filterable
              :options="monthBuy"
              :limit="2"
              :limitText="customLimitText"
              :multiple="true"
              :taggable="true"
              placeholder="Selecionar mês"
            />
          </div>
          <div class="col-md-6" >
            <label class="form-control-label">Meses para aplicar</label>
            <multiselect
              :required="true"
              v-model="formStructure.applicable_months"
              :disabled="!commercial.is_open"
              filterable
              :options="monthBuy"
              :limit="2"
              :limitText="customLimitText"
              :multiple="true"
              :taggable="true"
              placeholder="Selecionar mês"
            />
          </div>
        </div>
      </form>
    </validation-observer>
    <template slot="footer">
      <base-button type="secondary" @click="showModal = false">
        Fechar
      </base-button>
      <base-button
        type="success"
        :disabled="!commercial.is_open"
        @click="onSubmit"
      >
        Salvar
      </base-button
      >
    </template>
  </modal>
</template>

<script>
import Multiselect from "@/components/Multiselect/translated_multiselect.vue";
import { DatePicker } from "element-ui";
import { ValidationProvider, extend } from "vee-validate";
import { required, numeric, regex } from "vee-validate/dist/rules";
extend("required", {
  ...required,
  message: "Este campo é obrigatório",
});

export default {
  name: "product-modal",
  components: {
    Multiselect,
    [DatePicker.name]: DatePicker,
    ValidationProvider,
  },
  props: {
    commercial: {
      type: Object,
      required: true,
    },
    commercialBrand: {
      type: Object,
      required: true,
    },
    show: {
      type: Boolean,
      required: true,
    },
    monthBuy: {
      type: Array,
      required: true,
    },
    commercialProducts: {
      type: Array,
      required: false,
    },
    tablesErp: {
      type: Array,
      required: false,
    },
  },
  data() {
    return {
      formStructure: {
        packing: null,
        purchase_price: null,
        accrual_interest: null,
        gain_margin_product: null,
        unapplicable_months: [],
        discount_supplier: null,
        vegetal_interest: null,
        applicable_months: []
      },
      brandId: null,
      commercialBrands: [],
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        precision: 2,
        masked: false,
      },
      errors: [],
      selectedCommercialBrand: [],
      newAdditions: [],
      gainMarginKey: 0
    };
  },
  mounted() {
    
  },
  methods: {
    customLimitText(count) {
      return `+${count}`;
    },
    async onSubmit(){
      let eventData = null
      if (this.commercialProducts.length > 1) {
        const { packing, purchase_price, ...rest } = this.formStructure;
        eventData = rest
      } else {
        eventData = this.formStructure
      }

      eventData.additions_attributes = this.additions ? this.additions.filter(addition => addition.value != undefined && []) : []

      const validForm = await this.$refs.formValidator.validate()
      if (!validForm) return;
      this.$emit('submit', eventData);
      this.initFormStructure();
      this.showModal = false;
    },
    initFormStructure(){
      this.formStructure = {
        packing: null,
        gain_margin_product: null,
        purchase_price: null,
        accrual_interest: null,
        unapplicable_months: [],
        discount_supplier: null,
        vegetal_interest: null,
        applicable_months: []
      }
    },
    modalLabel(){
      if (this.commercialProducts.length == 1) return 'Atualizar Informações do Produto'
      
      return 'Atualizar Informações dos produtos'
    },
  },
  computed: {
    showModal: {
      get() {
        return this.show;
      },
      set(modal) {
        this.$emit("update:show", modal);
      },
    },
    additions: {
      get() {
        var additions = this.commercialProducts[0] ? this.commercialProducts[0].additions : []
        // if double
        additions = additions.slice(Math.max(additions.length - this.tablesErp.length , 0))

        this.newAdditions = additions

        let array = []
        let obj = {}
        let i = 0

        if (this.tablesErp.length > additions.length) {
          array = additions
          i = additions.length
        }

        // Implementing array addition
        for (let i = 0; i < this.tablesErp.length; i++) {
          const obj = {
            name: this.tablesErp[i].desc_cta,
            value: additions[i] ? additions[i].value : "",
            id: additions[i] ? additions[i].id : null,
            tabe_cta: this.tablesErp[i].tabe_cta,
            operation: additions[i] ? additions[i].operation : null
          };
          array.push(obj);
        }

        this.newAdditions = array

        return array
      },
      set(newValue) {
        this.additions_erp = newValue
      }
    }
  },
  watch: {
    commercialBrand: function() {
      this.gainMarginKey = this.gainMarginKey + 1
    },
    show: function(newValue) {
      if (!newValue) return;

      this.formStructure.vegetal_interest = this.commercialProducts[0].vegetal_interest
      this.formStructure.gain_margin_product = this.commercialProducts[0].gain_margin_product
      this.formStructure.discount_supplier = this.commercialProducts[0].discount_supplier
      this.formStructure.accrual_interest = this.commercialProducts[0].accrual_interest
      this.formStructure.purchase_price = this.commercialProducts[0].purchase_price
      this.formStructure.packing = this.commercialProducts[0].packing
      this.formStructure.unapplicable_months = this.commercialProducts[0].unapplicable_months
      this.formStructure.applicable_months = this.commercialProducts[0].applicable_months      
    }
  }
};
</script>
<style>
div.div-striped>div:nth-of-type(odd) {
  background: #F8F8F8;
  min-height: 100px;
}
.multiselect__strong{
  color: #FFFFFF;
  font: 12px "Open Sans";
  background-color: #41B883;
  padding: 3px 5px;
  border-radius: 0.25rem;
}
</style>
